import React from 'react';
import { Award, Globe, MessageCircle, Sparkles } from 'lucide-react';
import { profileData } from '../mock';

const credentials = [
  { icon: Award, label: 'Top Rated on Upwork, 5.0 rating' },
  { icon: Globe, label: 'Clients across 12 countries' },
  { icon: Sparkles, label: '7+ years of experience in Kit.com' },
  { icon: MessageCircle, label: '6,000+ hrs of email work shipped' },
];

const StrategistPanel = () => {
  return (
    <section className="container-x section" data-testid="strategist-panel">
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] rounded-[1.75rem] overflow-hidden bg-cream-2">
            <img
              src={profileData.image}
              alt="Akash Tiwari — Growth Hacking strategist"
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.src =
                  'https://images.unsplash.com/photo-1649433658557-54cf58577c68?w=900&q=80';
              }}
            />
            <div className="absolute top-4 left-4 float-card px-3 py-1.5">
              <p className="text-[10px] uppercase tracking-widest text-muted-warm">Available</p>
              <p className="text-sm font-bold text-ink">For 2 new clients · Q1</p>
            </div>
          </div>

          {/* Floating "Booked through May" mini card */}
          <div className="hidden md:block absolute -bottom-5 -right-5 float-card p-4 w-56 animate-float-y-slow">
            <p className="text-xs font-semibold text-ink">Akash Tiwari</p>
            <p className="text-[11px] text-muted-warm">Founder · Email Strategist</p>
            <div className="mt-3 flex -space-x-1.5">
              {[
                'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=80&q=70',
                'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&q=70',
                'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&q=70',
              ].map((u) => (
                <span key={u} className="w-7 h-7 rounded-full border-2 border-white overflow-hidden">
                  <img src={u} alt="" className="w-full h-full object-cover" />
                </span>
              ))}
              <span className="w-7 h-7 rounded-full bg-[var(--gh-orange)] text-white text-[10px] font-bold flex items-center justify-center border-2 border-white">
                +9
              </span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="text-xs uppercase tracking-[0.25em] text-[var(--gh-orange)] font-semibold">
            Meet your strategist
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold mt-4 leading-[1.05] text-ink">
            One operator who actually builds the system —{' '}
            <span className="font-serif italic text-[var(--gh-orange)]">not the deck</span>.
          </h2>
          <p className="mt-6 text-lg text-muted-warm leading-relaxed">
            I&apos;m Akash. For seven years I&apos;ve quietly run email programs for solopreneurs,
            podcasters, course creators and boutique e-commerce brands. No agency layers,
            no junior account exec — you talk to the same person who writes the welcome
            sequence and watches the deliverability graph.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-3">
            {credentials.map((c) => (
              <div
                key={c.label}
                data-testid={`credential-${c.label.toLowerCase().replace(/\s+/g, '-')}`}
                className="flex items-center gap-3 px-4 py-3 rounded-2xl bg-cream-2 border border-line"
              >
                <span className="w-9 h-9 rounded-xl bg-[var(--gh-orange-soft)] text-[var(--gh-orange)] flex items-center justify-center">
                  <c.icon className="w-4 h-4" />
                </span>
                <span className="text-sm font-medium text-ink">{c.label}</span>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap gap-3">
            <a
              href="https://tidycal.com/akashtiwari/30-minute-meeting"
              target="_blank" rel="noopener noreferrer"
              data-testid="strategist-book-call"
              className="btn-orange"
            >
              Book a 30-min strategy call
            </a>
            <a
              href="/case-studies"
              data-testid="strategist-case-studies-link"
              className="btn-outline"
            >
              See client outcomes
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StrategistPanel;
